import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const WelcomeModal = ({ show, onHide, userName }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="welcome-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Welcome to JobInfoNetwork!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Row className="text-center">
          <Col md={12} className="mb-3">
            <div className="welcome-message">
              <h4>
                Hello {userName || "Group Leader"}, we're glad you're here!
              </h4>
              <p>
                As a Group Leader, you play a vital role in connecting job
                seekers with opportunities. Here are a few things to help you
                get started:
              </p>
              <ul className="text-start mt-4">
                <li>Invite support team members to join your group</li>
                <li>Manage and track job seekers in your dashboard</li>
                <li>Review job postings to share with your network</li>
                <li>Explore the features available to you as a Group Leader</li>
              </ul>
            </div>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <Col md={6} className="mb-3">
            <div className="option-card p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                <h4>Need Help?</h4>
                <p>
                  Learn more about how JobInfoNetwork can help your organization
                  connect job seekers with opportunities.
                </p>
              </div>
              <a
                href="https://jobinfonetwork.com/help"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary mt-3 text-center justify-content-center w-100"
              >
                View Resources
              </a>
            </div>
          </Col>
          <Col md={6} className="mb-3">
            <div className="option-card p-4 h-100 d-flex flex-column justify-content-between">
              <div>
                <h4>Grow Your Support Team</h4>
                <p>
                  Invite support team members to help manage job seekers and
                  expand your reach.
                </p>
              </div>
              <Link
                to="/groupleader/supportteammembers"
                className="btn btn-success mt-3 text-center justify-content-center w-100"
              >
                Manage Support Team
              </Link>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="text-center">
          Get Started
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WelcomeModal;
